export const firebaseConfig = {
  apiKey: 'AIzaSyDQb19RJIoBDAAnwLzdUI--IY_hzbxRpcA',
  authDomain: 'morland-sandvik.firebaseapp.com',
  databaseURL: 'https://morland-sandvik.firebaseio.com',
  storageBucket: 'morland-sandvik.appspot.com',
};
